export default __webpack_public_path__ + "static/media/product-14 (2).f419f58a.jpg";